<div class="so-section-card" [class.so-section-card--disabled]="disabled()">
  <button
    type="button"
    class="so-section-card__button"
    [class.so-section-card__button--active]="isActive()"
    [class.so-section-card__button--disabled]="disabled()"
    [style.--border-color]="effectiveBorderColor()"
    [style.min-height.px]="cardHeight()"
    [disabled]="disabled()"
    (click)="handleClick()">
    
    <div class="so-section-card__content">
      <div class="so-section-card__icon-wrapper">
        @if (svgIcon() || icon()) {
          <so-premium-icon-ui
            [icon]="svgIcon() || icon()"
            [color]="borderColor()"
            [size]="iconSize()"
            [padding]="iconPadding()"
            [borderRadius]="iconBorderRadius()" />
        }
      </div>
      
      <div class="so-section-card__text">
        <span class="so-section-card__title">{{ title() }}</span>
        @if (subtitle()) {
          <span class="so-section-card__subtitle">{{ subtitle() }}</span>
        }
      </div>
    </div>
    
    <div class="so-section-card__border" [style.background-color]="effectiveBorderColor()"></div>
  </button>
</div>
